"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formattedBrokerNames = void 0;
exports.formattedBrokerNames = {
    degiro: 'Degiro',
    etoro: 'eToro',
    xtbOld: 'XTB-old',
    xtbNew: 'XTB',
    trading212: 'Trading 212',
    interactiveBrokers: 'Interactive Brokers',
    monery: 'Monery',
    coinbase: 'Coinbase',
    anycoin: 'Anycoin',
    portu: 'Portu',
    binance: 'Binance',
    fio: 'Fio e-Broker',
    snowball: 'Snowball',
    yahooFinance: 'Yahoo Finance',
    coinmate: 'Coinmate',
    patria: 'Patria Finance',
    lynx: 'LYNX',
    coinbasePro: 'Coinbase Pro',
    revolut: 'Revolut',
};
//# sourceMappingURL=formatted-broker-names.js.map